import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetMultiAccountUsersApiResponse } from "./api/generated";

export interface MultiUserState {
  multiUsers: GetMultiAccountUsersApiResponse | undefined;
}

const multiUserInitialState: MultiUserState = {
  multiUsers: [],
};

const MultiUserSlice = createSlice({
  name: "multiUser",
  initialState: multiUserInitialState,
  reducers: {
    setMultiUserData: (
      state: MultiUserState,
      action: PayloadAction<GetMultiAccountUsersApiResponse>,
    ): void => {
      state.multiUsers = action.payload;
    },
  },
});

export const { setMultiUserData } = MultiUserSlice.actions;

export default MultiUserSlice;
